import {Component} from "@angular/core";
import {AppConfig} from "../../util/appConfig";
import {IbcServices} from "../../services/ibc.services";
import {AppDialog} from "../../component/appDialog";
import {AlertController, App, LoadingController, Platform} from "ionic-angular";
import {HabaServices} from "../../services/haba.services";
import {HabaGames} from "../habaGames/habaGames";
import {CommonService} from "../../services/common.service";
import {RechargePage} from "../recharge/recharge";
import {WithDrawalPage} from "../withDrawal/withDrawal";
import {FundTransferPage} from "../fundTransfer/fundTransfer";
import {ServicePage} from "../service/service";
import {LivecasinoPage} from "../livecasino/livecasino";
import {EbetService} from "../../services/ebet.service";
import {HomePage} from "../home/home";
import {ScreenOrientation} from '@ionic-native/screen-orientation';
import {StatusBar} from "ionic-native";
import {InAppBrowser, InAppBrowserOptions} from '@ionic-native/in-app-browser';
import {BancaServices} from "../../services/banca.services";
import {ToastController} from "ionic-angular";
import { UserService } from '../../services/user.services';

import { BauCua1GiayPage } from '../baucua1giay/baucua1giaypage';
import { OanTuTiPage } from '../oantuti/oantutipage';
import { BauCua1PhutPage } from '../baucua1phut/baucua1phutpage';
import { LotteryTabsPage } from '../lotteryTabPanel/lotteryTabPanel';
import { TranslateService } from "ng2-translate";
@Component({
    templateUrl: 'thirdpartyGame.html',
    selector: 'third-party-game',
})

export class ThirdpartyGame {
    private thirdPartyGamesList = AppConfig.thirdpartyGames;
    public isAccountTest: boolean = true;
    tabList: any[] = [];
    menuList: any[] = [];
    livefblist: any[];
    tabSelect: string = 'xoso';
    private lotteryList: any[] = AppConfig.LotteryList(this.translate);
    private thirdpartyGamesList: any[];
    dayCurrent: number = new Date().getDay();
    

    options: InAppBrowserOptions = {
        location: 'yes',//Or 'no'
        hidden: 'no', //Or  'yes'
        clearcache: 'yes',
        clearsessioncache: 'yes',
        zoom: 'yes',//Android only ,shows browser zoom controls
        hardwareback: 'yes',
        mediaPlaybackRequiresUserAction: 'no',
        shouldPauseOnSuspend: 'no', //Android only
        closebuttoncaption: 'Close', //iOS only
        disallowoverscroll: 'no', //iOS only
        toolbar: 'yes', //iOS only
        enableViewportScale: 'no', //iOS only
        allowInlineMediaPlayback: 'no',//iOS only
        presentationstyle: 'pagesheet',//iOS only
        fullscreen: 'yes',//Windows only
    };

    private dataSport: any;

    constructor(private alertCtrl: AlertController,private userService: UserService, private ibcService: IbcServices, private app: App, private loadingCtrl: LoadingController, private habaServices: HabaServices, public cs: CommonService, private ebetServices: EbetService,
                public platform: Platform, private screenOrientation: ScreenOrientation, private theInAppBrowser: InAppBrowser
                , private bancaService: BancaServices,private toastCtrl: ToastController, private translate: TranslateService) {
        if (this.cs.userType > 1) {
            this.isAccountTest = false;
        }
    }

    ngOnInit() {
        this.initData();
        this.tabSelect='xoso';
    }

    initData() {
        this.userService.initHome(undefined, this.alertCtrl).then((data) => {
            if (data['msg'] == '') {
                HomePage.zaloID = data['zaloID'];
                this.tabList = data['tabList'];
                this.menuList = data['menuList'];
                this.livefblist = data['livefblist'];
                this.filterTabMatch(this.tabSelect);
            }
        });
    }

    handleChangeTab(tabValue: any) {
        this.tabSelect = tabValue;
        this.filterTabMatch(tabValue);
    }
    filterTabMatch(tabSelect: string) {
        // filter lottery list
        let newLotteryList = JSON.parse(JSON.stringify(AppConfig.LotteryList(this.translate)));
        newLotteryList = newLotteryList.filter((item) => item.tabMath.includes(tabSelect));
        this.lotteryList = newLotteryList;
        //filter thirdgame party list
        let newThirdPartyGameList = JSON.parse(JSON.stringify(this.menuList));

        newThirdPartyGameList = newThirdPartyGameList.filter((item) => item.type === tabSelect); 
        this.thirdpartyGamesList = newThirdPartyGameList;
        this.thirdpartyGamesList = this.thirdpartyGamesList.map((item: any) => {
            if (item.type == 'xoso') {
                item.child.map((item1: any) => {
                    if (item1.subType == 'mn' || item1.subType == 'mt') {
                        item1.isCollapse = true;
                        item1.child.map((item2: any) => {
                            if (item2.openday.includes(this.dayCurrent)) {
                                item2.hide = false;
                            } else item2.hide = true;
                            return item2;
                        });
                    }
                    return item1;
                });
            }
            return item;
        });
    }

    

    onCollapseGame(event: any, clsItem: string, isCollapse: boolean) {
        const gameSection = event.target.closest('.gameSection');
        if (gameSection) {
            gameSection.classList.toggle('toggle');
        }

        this.thirdpartyGamesList = this.thirdpartyGamesList.map((item: any) => {
            if (item.type == 'xoso') {
                item.child.map((item1: any) => {
                    if (item1.subType == 'mn' || item1.subType == 'mt') {
                        item1.child.map((item2: any) => {
                            if (isCollapse) {
                                item2.hide = false;
                            } else {
                                if (item2.openday.includes(this.dayCurrent)) {
                                    item2.hide = false;
                                } else item2.hide = true;
                            }
                        });
                    }
                    item1.isCollapse = !isCollapse;
                    return item1;
                });
            }
            return item;
        });

        this.lotteryList = this.lotteryList.map((item: any) => {
            if (item.clsItem == clsItem) {
                item.children.map((item1: any) => {
                    if (isCollapse) {
                        item1.hide = false;
                    } else {
                        if (item1.openDay.includes(this.dayCurrent)) {
                            item1.hide = false;
                        } else item1.hide = true;
                    }

                    return item1;
                });

                item.isCollapse = !isCollapse;

                return item;
            }

            return item;
        });
    }

    goLottery(lotteryCode: string, lotteryDesc: string, keyLaunch: string, lotteryName: string) {
        // if (!this.isLogged) {
        //     this.onLogin();
        //     return;
        // }

        // //check server is maintain
        // if (this.cs.isMaintain) {
        //     AppDialog.alert({
        //         alertCtrl: this.alertCtrl,
        //         message: 'Lỗi kết nối',
        //     });
        //     return;
        // }

        let pageRedirect = null;
        if (Number(keyLaunch) === 92) {
            // baucua1giay
            pageRedirect = BauCua1GiayPage;
        } else if (Number(keyLaunch) === 93) {
            // baucua1phut
            pageRedirect = BauCua1PhutPage;
        } else if (Number(keyLaunch) === 94) {
            pageRedirect = OanTuTiPage;
        } else {
            pageRedirect = LotteryTabsPage;
        }

        if (pageRedirect) {
            this.app.getRootNav().push(pageRedirect, {
                lotteryName: lotteryCode,
                title: lotteryDesc,
                lotteryId: keyLaunch,
                titleGame: lotteryName,
            });
        } else {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Page không tồn tại!',
            });
        }
    }

    goToThirdPartyGame(keyLaunch: string) {

        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.',
            });
            return;
        }
        AppDialog.toast({
            toastCtrl: this.toastCtrl,
            message: 'Comming Soon',
        });
        /*this.thirdpartyGameService
            .launchGame({}, keyLaunch, this)
            .then((data) => {
                let dataSport;
                if (data['msg'] === '') {
                    dataSport = { token: data['ibcSessionToken'] };
                } else {
                    dataSport = { msg: data['msg'] };
                }

                if (dataSport.hasOwnProperty('msg') && dataSport.msg !== '') {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: dataSport.msg,
                    });
                } else {
                    this.theInAppBrowser.create(data['url'], '_system', this.options);
                }
            })
            .catch((error) => {
                LoginPage.paramUserLogin = '';

                this.isLogged = false;
            });*/
    }


    ionViewWillEnter() {}

    gotoPage(page: any) {
        AppDialog.toast({
            toastCtrl: this.toastCtrl,
            message: 'Comming Soon',
        });
        /* if (page === "sportPage") {
            this.ibcService.loginIBC({}, this).then(data => {
                let dataSport;
                if (data['msg'] === '') {
                    dataSport = {token: data['ibcSessionToken']};
                } else {
                    dataSport = {msg: data["msg"]};
                }

                if (dataSport.hasOwnProperty('msg') && dataSport.msg !== '') {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: dataSport.msg
                    });
                } else {
                    this.theInAppBrowser.create('https://ismart.gsoft-ib.com/deposit_ProcessLogin.aspx?lang=vn&st=' + dataSport.token, "_system", this.options);
                }
            });
        } else if (page === "sport2Page") {
            this.ibcService.loginIBC2({}, this).then(data => {
                let dataSport;
                if (data['msg'] === '') {
                    dataSport = {token: data['ibcSessionToken']};
                } else {
                    dataSport = {msg: data["msg"]};
                }

                if (dataSport.hasOwnProperty('msg') && dataSport.msg !== '') {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: dataSport.msg
                    });
                } else {
                    this.theInAppBrowser.create('https://ismart.ig128.com/deposit_processlogin.aspx?lang=vn&token=' + dataSport.token, "_system", this.options);
                }
            });
        } else if (page === "habaPage") {
            this.habaServices.habaLogin({}, this).then(data => {
                if (data['msg'] === '') {
                    this.app.getRootNav().push(HabaGames, data);
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            });
        } else if (page === 'livecasinoPage') {
            this.ebetServices.ebetLogin({}, this).then(data => {
                if (data['msg'] === '') {
                    this.platform.ready().then(() => {
                        if (!this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                            this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
                            setTimeout(() => {
                                this.app.getRootNav().push(LivecasinoPage, data);
                            }, 1000);
                        } else { // is wap
                            this.theInAppBrowser.create("http://hk.oplive.info:8080/?infoUrl=h5/3df1a6&username=" + data["username"] + "&accessToken=" + data["accessToken"], "_system", this.options);
                        }
                    });
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            });
        } else if (page === 'bancaPage') {
            let params = {gametype: 110};
            this.bancaService.getForwardLink(params, this).then(data => {
                if (data['message'] === '') {
                    this.platform.ready().then(() => {
                        if (!this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                            this.theInAppBrowser.create(data['linkGameForward'], "_system", this.options);
                        } else { // is wap
                            //this.theInAppBrowser.create("/game-play.html?urlgameplay="+data['linkGameForward'], "_system", this.options);
                            window.location.href = data['linkGameForward'];
                        }
                    });
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data['message']
                    });
                }
            });
        } */
    }

    recharge() {
        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.'
            });
        } else {
            this.app.getRootNav().push(RechargePage);
        }
    }

    withDrawal() {
        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.'
            });
        } else {
            this.app.getRootNav().push(WithDrawalPage);
        }
    }

    fundTransfer() {
        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.'
            });
        } else {
            this.app.getRootNav().push(FundTransferPage);
        }
    }

    contact() {
        let alertCmp = this.alertCtrl.create({
            title: "Hỗ Trợ 24/7",
            cssClass: 'alertSupport247',
            message:
            '<div class="support247">' +
            '<div title="hotro"><img src="build/assets/images/home/supportOnline.png" />Hỗ Trợ</div>' +
            /*'<div title="zalo"><img src="build/assets/images/home/zaloicon.png" />Zalo</div>' +*/
            '</div>',
            buttons: [{text: 'Đóng'}]
        });
        alertCmp.present().then(() => {
            const elSupport: any = document.querySelectorAll('.support247 > div');
            for (let i = 0; i < elSupport.length; i++) {
                elSupport[i].addEventListener('click', (e) => {
                    let getFlag = elSupport[i].getAttribute('title');
                    alertCmp.dismiss();
                    if (getFlag === 'hotro') {
                        this.app.getRootNav().push(ServicePage);
                    }
                    /*else if (getFlag === 'zalo') {
                                            if (HomePage.zaloID !== '') {
                                                this.theInAppBrowser.create('https://zalo.me/'+HomePage.zaloID, "_system", this.options);
                                            }else {
                                                AppDialog.alert({
                                                    alertCtrl: this.alertCtrl,
                                                    message: 'Chưa tồn tại Zalo Support. Vui lòng chọn Hỗ Trợ!'
                                                });
                                            }
                                        }*/
                });
            }
            return;
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/thirdpartyGame/thirdpartyGame.ts